import React from "react";
import { withTranslation } from "react-i18next";
import { Box, Button, Grid, Typography } from "@mui/material";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import PropTypes from "prop-types";

import InputFieldText from "Components/Common/InputFieldText";
import { getOptionValue } from "common/enums";

const ResponsiblePersonDetails = ({ formik, t }) => {
  const {
    values: { responsiblePersonAuthorities },
    setFieldValue,
    setFieldTouched,
  } = formik;

  const handleAddNewResponsiblePerson = (existingResponsiblePersonList) => {
    const newResponsiblePersonList = [
      ...existingResponsiblePersonList,
      {
        id: 0,
        name: "",
        mobileNumber: "",
        email: "",
        designation: "",
        buildingAuthorityRoleId: getOptionValue(
          "buildingAuthorityRoleEnum",
          "Responsible Person"
        ),
      },
    ];

    setFieldValue("responsiblePersonAuthorities", newResponsiblePersonList);
    setFieldTouched(
      `responsiblePersonAuthorities[${newResponsiblePersonList.length - 1}]`,
      false,
      false
    );
  };

  const handleRemoveResponsiblePersonClick = (index) => {
    if (responsiblePersonAuthorities.length > 3) {
      setFieldValue(
        "responsiblePersonAuthorities",
        responsiblePersonAuthorities.filter((_, ind) => ind !== index)
      );
    }
  };

  return (
    <Grid item xs={12} className="border ps-3 pe-2 pb-2 pt-0" sx={{ mb: 3 }}>
      <Grid item xs={12} className="mt-3">
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <Box>
            <Typography className="mb-3 me-3" lineHeight={1} variant="h6">
              {t("Responsible Person")}
            </Typography>
          </Box>
          <Box>
            <Button
              color="primary"
              className="mb-3"
              sx={{ minWidth: "unset", textTransform: "capitalize" }}
              variant="outlined"
              onClick={() =>
                handleAddNewResponsiblePerson(responsiblePersonAuthorities)
              }
            >
              <strong>
                <span>+</span> {t("Add Responsible Person")}
              </strong>
            </Button>
          </Box>
        </Box>
      </Grid>
      {!!responsiblePersonAuthorities.length &&
        responsiblePersonAuthorities.map((_, index) => (
          <Grid
            key={index}
            container
            columnSpacing={1}
            rowSpacing={1}
            className="border p-2 pe-3 mt-2"
          >
            <Grid item xs={12}>
              <Typography
                className="mb-0"
                lineHeight={1}
                variant="h6"
                sx={{ fontSize: "16px" }}
              >
                {t("Level") + ` ${index + 1} :`}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InputFieldText
                label={t("Name") + "*"}
                name={`responsiblePersonAuthorities.${index}.name`}
                formik={formik}
                placeholder="Enter Name"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InputFieldText
                label={t("Designation") + "*"}
                name={`responsiblePersonAuthorities.${index}.designation`}
                formik={formik}
                placeholder="Enter Designation"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InputFieldText
                label={t("Mobile Number") + "*"}
                name={`responsiblePersonAuthorities.${index}.mobileNumber`}
                type="number"
                formik={formik}
                placeholder="Enter Mobile Number"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InputFieldText
                label={t("Email") + "*"}
                name={`responsiblePersonAuthorities.${index}.email`}
                formik={formik}
                placeholder="Enter Email"
              />
            </Grid>
            {responsiblePersonAuthorities.length > 3 && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  color="error"
                  size="small"
                  sx={{
                    minWidth: "unset",
                    border: "1px solid",
                    height: "40px",
                    width: "100px",
                    mb: 2,
                  }}
                  onClick={() => handleRemoveResponsiblePersonClick(index)}
                >
                  <strong className="d-flex justify-content-center">
                    <DeleteOutlineSharpIcon fontSize="small" />
                    {t("Remove")}
                  </strong>
                </Button>
              </Grid>
            )}
          </Grid>
        ))}
    </Grid>
  );
};

ResponsiblePersonDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(ResponsiblePersonDetails);
